import React from "react"
import PropTypes from "prop-types"
import theme from "styles/theme"
import { ReactComponent as Quote } from "images/quote.svg"

const QuoteBlock = ({ quote, attribution }) => (
  <div
    css={{
      color: theme.textGray,
      maxWidth: 660,
      margin: "40px 0",
      display: "flex",
      [theme.mobile]: {
        display: "block",
      },
    }}
  >
    <QuoteIcon />
    <div>
      <span
        css={{
          ...theme.blockquoteText,
          background: `linear-gradient(transparent 20%, ${theme.lightBlue30} 20%)`,
          boxShadow: `0 0.05em 0 ${theme.lightBlue30}`,
        }}
      >
        {quote}
      </span>
      {attribution && (
        <div css={[theme.blockquoteCaption, { marginTop: 15 }]}>
          — {attribution}
        </div>
      )}
    </div>
  </div>
)

export default QuoteBlock

QuoteBlock.propTypes = {
  quote: PropTypes.string.isRequired,
  attribution: PropTypes.string,
}

const QuoteIcon = () => (
  <Quote
    css={{
      color: theme.midBlue,
      width: 50,
      height: 36,
      marginTop: 12,
      marginRight: 16,
      flexShrink: 0,
      [theme.navBreak]: {
        width: 42,
        marginTop: 11,
        marginRight: 19,
      },
      [theme.mobile]: {
        width: 36,
        marginBottom: 12,
        marginTop: 0,
      },
    }}
  />
)
